// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App_app__kjqwC {
	position: relative;
}

.App_dashboard__iYTfa {
	background: #052E26 !important;
}

.App_notFoundWrapper__I4uPM {
	height: calc(100vh - 146px);
}

.App_notFoundParent__F4abM {
	/* margin-top: 100px; */
	max-width: 480px;
}

.App_notFoundImage__zVi6u {
	height: 680px;
	width: auto;
	aspect-ratio: auto;
	/* transform: rotate(-84.698deg); */
	flex-shrink: 0;
	top: auto;
	bottom: auto;
	right: 100%;
}

.App_notFoundTitle__KMiia {
	color: #000;
	font-family: 'Clash Display';
	font-size: 128px;
	font-style: normal;
	font-weight: 600;
	line-height: normal;
}

.App_notFoundSubTitle__lf6fR {
	color: #000;
	font-family: Clash Display;
	font-size: 64px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;
}

.App_notFoundMessage__s1Yct {
	color: #000;
	text-align: center;
	font-family: Manrope;
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: normal;
	max-width: 404px;
	margin-top: 13px;
}

.App_notFoundButton__jsfXh {
	display: flex;
	padding: 13px 34px;
	border: none;
	border-radius: 12px;
	background: #052E26;
	color: #fff7e9;
	font-family: Manrope;
	font-size: 16px;
	font-style: normal;
	font-weight: 600;
	line-height: normal;
	margin-top: 42px;
}

/* -----------------Media-Queries---------------------- */
@media only screen and (max-width: 900px) and (min-width: 821px) {
}

@media only screen and (max-width: 820px) and (min-width: 481px) {
	.App_notFoundImage__zVi6u {
		left: -100px;
		right: initial;
		top: -100%;
		bottom: initial;
		transform: rotate(40deg);
	}

	/* .notFoundTitle {
		font-size: 80px;
	}

	.notFoundSubTitle {
		font-size: 48px;
	}

	.notFoundMessage {
		font-size: 30px;
	} */
}

@media only screen and (max-width: 480px) {
	.App_notFoundImage__zVi6u {
		top: -350px;
		bottom: initial;
		left: auto;
		right: auto;
		height: calc(100vw + 100px);
		width: auto;
		aspect-ratio: auto;
		transform: rotate(-84.698deg);
	}

	.App_notFoundTitle__KMiia {
		color: #000;
		font-family: Clash Display;
		font-size: 60px;
		font-style: normal;
		font-weight: 600;
		line-height: normal;
	}

	.App_notFoundSubTitle__lf6fR {
		color: #000;
		font-family: Clash Display;
		font-size: 28px;
		font-style: normal;
		font-weight: 400;
		line-height: normal;
		margin-top: 10px;
	}

	.App_notFoundMessage__s1Yct {
		color: #000;
		text-align: center;
		font-family: Manrope;
		font-size: 14px;
		font-style: normal;
		font-weight: 500;
		line-height: normal;
		width: 354px;
	}

	.App_notFoundButton__jsfXh {
		display: flex;
		padding: 13px 34px;
		align-items: flex-start;
		gap: 10px;
		color: #fff7e9;
		font-family: Manrope;
		font-size: 14px;
		font-style: normal;
		font-weight: 600;
		line-height: normal;
	}
}
`, "",{"version":3,"sources":["webpack://./src/styles/App.module.css"],"names":[],"mappings":"AAAA;CACC,kBAAkB;AACnB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,uBAAuB;CACvB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,WAAW;CACX,kBAAkB;CAClB,mCAAmC;CACnC,cAAc;CACd,SAAS;CACT,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,WAAW;CACX,4BAA4B;CAC5B,gBAAgB;CAChB,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,0BAA0B;CAC1B,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;CACnB,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,kBAAkB;CAClB,YAAY;CACZ,mBAAmB;CACnB,mBAAmB;CACnB,cAAc;CACd,oBAAoB;CACpB,eAAe;CACf,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA,yDAAyD;AACzD;AACA;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;EACd,UAAU;EACV,eAAe;EACf,wBAAwB;CACzB;;CAEA;;;;;;;;;;IAUG;AACJ;;AAEA;CACC;EACC,WAAW;EACX,eAAe;EACf,UAAU;EACV,WAAW;EACX,2BAA2B;EAC3B,WAAW;EACX,kBAAkB;EAClB,6BAA6B;CAC9B;;CAEA;EACC,WAAW;EACX,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;CACpB;;CAEA;EACC,WAAW;EACX,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;CACb;;CAEA;EACC,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;CACpB;AACD","sourcesContent":[".app {\n\tposition: relative;\n}\n\n.dashboard {\n\tbackground: #052E26 !important;\n}\n\n.notFoundWrapper {\n\theight: calc(100vh - 146px);\n}\n\n.notFoundParent {\n\t/* margin-top: 100px; */\n\tmax-width: 480px;\n}\n\n.notFoundImage {\n\theight: 680px;\n\twidth: auto;\n\taspect-ratio: auto;\n\t/* transform: rotate(-84.698deg); */\n\tflex-shrink: 0;\n\ttop: auto;\n\tbottom: auto;\n\tright: 100%;\n}\n\n.notFoundTitle {\n\tcolor: #000;\n\tfont-family: 'Clash Display';\n\tfont-size: 128px;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: normal;\n}\n\n.notFoundSubTitle {\n\tcolor: #000;\n\tfont-family: Clash Display;\n\tfont-size: 64px;\n\tfont-style: normal;\n\tfont-weight: 400;\n\tline-height: normal;\n}\n\n.notFoundMessage {\n\tcolor: #000;\n\ttext-align: center;\n\tfont-family: Manrope;\n\tfont-size: 16px;\n\tfont-style: normal;\n\tfont-weight: 500;\n\tline-height: normal;\n\tmax-width: 404px;\n\tmargin-top: 13px;\n}\n\n.notFoundButton {\n\tdisplay: flex;\n\tpadding: 13px 34px;\n\tborder: none;\n\tborder-radius: 12px;\n\tbackground: #052E26;\n\tcolor: #fff7e9;\n\tfont-family: Manrope;\n\tfont-size: 16px;\n\tfont-style: normal;\n\tfont-weight: 600;\n\tline-height: normal;\n\tmargin-top: 42px;\n}\n\n/* -----------------Media-Queries---------------------- */\n@media only screen and (max-width: 900px) and (min-width: 821px) {\n}\n\n@media only screen and (max-width: 820px) and (min-width: 481px) {\n\t.notFoundImage {\n\t\tleft: -100px;\n\t\tright: initial;\n\t\ttop: -100%;\n\t\tbottom: initial;\n\t\ttransform: rotate(40deg);\n\t}\n\n\t/* .notFoundTitle {\n\t\tfont-size: 80px;\n\t}\n\n\t.notFoundSubTitle {\n\t\tfont-size: 48px;\n\t}\n\n\t.notFoundMessage {\n\t\tfont-size: 30px;\n\t} */\n}\n\n@media only screen and (max-width: 480px) {\n\t.notFoundImage {\n\t\ttop: -350px;\n\t\tbottom: initial;\n\t\tleft: auto;\n\t\tright: auto;\n\t\theight: calc(100vw + 100px);\n\t\twidth: auto;\n\t\taspect-ratio: auto;\n\t\ttransform: rotate(-84.698deg);\n\t}\n\n\t.notFoundTitle {\n\t\tcolor: #000;\n\t\tfont-family: Clash Display;\n\t\tfont-size: 60px;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: normal;\n\t}\n\n\t.notFoundSubTitle {\n\t\tcolor: #000;\n\t\tfont-family: Clash Display;\n\t\tfont-size: 28px;\n\t\tfont-style: normal;\n\t\tfont-weight: 400;\n\t\tline-height: normal;\n\t\tmargin-top: 10px;\n\t}\n\n\t.notFoundMessage {\n\t\tcolor: #000;\n\t\ttext-align: center;\n\t\tfont-family: Manrope;\n\t\tfont-size: 14px;\n\t\tfont-style: normal;\n\t\tfont-weight: 500;\n\t\tline-height: normal;\n\t\twidth: 354px;\n\t}\n\n\t.notFoundButton {\n\t\tdisplay: flex;\n\t\tpadding: 13px 34px;\n\t\talign-items: flex-start;\n\t\tgap: 10px;\n\t\tcolor: #fff7e9;\n\t\tfont-family: Manrope;\n\t\tfont-size: 14px;\n\t\tfont-style: normal;\n\t\tfont-weight: 600;\n\t\tline-height: normal;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"app": `App_app__kjqwC`,
	"dashboard": `App_dashboard__iYTfa`,
	"notFoundWrapper": `App_notFoundWrapper__I4uPM`,
	"notFoundParent": `App_notFoundParent__F4abM`,
	"notFoundImage": `App_notFoundImage__zVi6u`,
	"notFoundTitle": `App_notFoundTitle__KMiia`,
	"notFoundSubTitle": `App_notFoundSubTitle__lf6fR`,
	"notFoundMessage": `App_notFoundMessage__s1Yct`,
	"notFoundButton": `App_notFoundButton__jsfXh`
};
export default ___CSS_LOADER_EXPORT___;
